module.exports = __webpack_public_path__ + "img/sm4_livinguard_s.2f2ea2b8.png";